import React, { useRef } from 'react';

export const PeerjsContext = React.createContext();

const PeerjsProvider = ({ children }) => {
  let peer = useRef(null);
  return (
    <PeerjsContext.Provider value={peer}>
      {children}
    </PeerjsContext.Provider>
  )
}

export default PeerjsProvider;